<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="screenWidth < 1440 ? 24 : 36">
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="请输入项目名称" v-model="searchModel.name" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-range-picker
                :placeholder="['中标起始', '结束时间']"
                v-model="searchModel.winningTimeRange"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-select
                allowClear
                showSearch
                optionFilterProp="children"
                placeholder="请选择项目类型"
                v-model="searchModel.type"
              >
                <a-select-option v-for="(item, index) in projectTypeList" :key="index" :value="item.code">{{ item.name }}</a-select-option>
                <!-- <a-select-option :value="1">纯软件</a-select-option>
                <a-select-option :value="2">项目集成</a-select-option> -->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="search">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="true" v-show="showExpend">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" v-if="true" v-show="showExpend" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MarketsSearchForm',
  mounted () {},
  computed: {
    screenWidth () {
      return document.body.clientWidth
    },
    ...mapGetters(['projectTypeList'])
  },
  data () {
    return {
      showExpend: false,

      searchModel: {},
      advanced: false // 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.name) {
        model.name = model.name.trim()
      }
      for (var item in model) {
        if (!model[item] && model[item] !== 0) {
          delete model[item]
        }
      }
      if (model.winningTimeRange && model.winningTimeRange.length === 0) {
        delete model.winningTimeRange
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}

      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表
  }
}
</script>

<style scoped>
</style>
